// components/WeatherCard.js
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import moment from "moment";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const WeatherCard = () => {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const res = await fetch(`${API_BASE}/weather`);
        const json = await res.json();
        setWeather(json);
      } catch (err) {
        console.error("Failed to load weather data:", err);
        setWeather(null);
      } finally {
        setLoading(false);
      }
    };

    fetchWeather();
  }, []);

  if (loading) return <Spinner color="primary" />;
  if (!weather || !weather.lastData) return <p>Error loading weather data</p>;

  const { lastData } = weather;
  const time = new Date(lastData.date).toLocaleTimeString();

  const now = new Date();
  const lastRain = new Date(lastData.lastRain);
  const lastRainTimeAgo = moment(lastRain).fromNow();
  const diffHours = (now - lastRain) / (1000 * 60 * 60);

  const rainDisplay = diffHours <= 48
    ? `${lastData.eventrainin}"`
    : lastRainTimeAgo;

  const rainLabel = diffHours <= 48
    ? "Event Rain"
    : "Last Rain";

  return (
    <Card className="shadow bg-gradient-info text-white">
      <CardBody className="pt-2 pb-3">
        <Row className="text-center">
          <Col xs="4">
            <div>
              <i className="fas fa-thermometer-half fa-2x mb-2" />
              <div style={{ fontSize: "1.2rem" }}>{lastData.tempf}&deg;F</div>
              <small>Temp</small>
            </div>
          </Col>
          <Col xs="4">
            <div>
              <i className="fas fa-cloud-rain fa-2x mb-2" />
              <div style={{ fontSize: "1.2rem" }}>{rainDisplay}</div>
              <small>{rainLabel}</small>
            </div>
          </Col>
          <Col xs="4">
            <div>
              <i className="fas fa-wind fa-2x mb-2" />
              <div style={{ fontSize: "1.2rem" }}>{lastData.windspeedmph} mph</div>
              <small>Wind Speed</small>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
    
  );
};

export default WeatherCard;
